import { render } from "./FileUploadView.vue?vue&type=template&id=30b693fb"
import script from "./FileUploadView.vue?vue&type=script&lang=js"
export * from "./FileUploadView.vue?vue&type=script&lang=js"

import exportComponent from "/home/simon/workspace/tasman/3palette/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__